import $ from 'jquery';

class CustomFileInput {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.inputLabel = document.querySelector(`.custom-file-label[for='${$(this.DOM.el).attr('id')}']`);

        this.initEvents();
    }

    initEvents() {
        /* Add event listener */
        this.DOM.el.addEventListener('change', () => {
            const files = Array.from(this.DOM.el.files);
            this.DOM.inputLabel.innerText = files.map(file => file.name).join(", ");
        });
    }
}

const fileInputNodes = Array.from(document.querySelectorAll('.custom-file-input'));
if (fileInputNodes !== null) {
    fileInputNodes.forEach((fileInput) => { new CustomFileInput(fileInput); });
}
